import {Row} from './../../common/Layouts/Layouts';
import ProgressBar from './../ProgressBar/ProgressBar';
import {getStarRatingColor} from '@stencil/hotels-utils/src/get-ratings-colors';

import {
  WrapperDiv,
  ReviewTypeTextWrapper,
  ProgressBarWrapperDiv,
  StarDiv,
  ProgressBarCountWrapper,
} from './RatingsBreakup.styles';

const RatingsBreakup = ({rwc}) => {
  const getBarWidth = rating => {
    let barWidth = (rating * 27) / 100;
    return barWidth;
  };

  return (
    <WrapperDiv>
      {rwc &&
        rwc.map((item, i) => (
          <Row key={`${item.name}-${i}`}>
            <ReviewTypeTextWrapper>{item.name.charAt(0)}</ReviewTypeTextWrapper>
            <StarDiv />
            <ProgressBarWrapperDiv>
              <ProgressBar
                width={getBarWidth(item.rating)}
                bgColor={getStarRatingColor(item.name.charAt(0))}
              />
            </ProgressBarWrapperDiv>
            <ProgressBarCountWrapper>{item.count}</ProgressBarCountWrapper>
          </Row>
        ))}
    </WrapperDiv>
  );
};

export default RatingsBreakup;
